import { mix } from "@chorda/core";
export const CardImage = (props) => {
    return {
        templates: {
            content: props.image
        }
    };
};
export const CardHeader = (props) => {
    return {
        components: {
            title: {
                text: props.title
            },
            icon: props.icon || false
        }
    };
};
export const Card = (props) => {
    return mix({
        css: 'card',
        components: {
            image: false,
            footer: false
        },
        templates: {
            header: {
                css: 'card-header',
                weight: -20,
                components: false,
                templates: {
                    title: {
                        css: 'card-header-title'
                    },
                    icon: {
                        css: 'card-header-icon'
                    }
                },
                reactions: {
                    model: (v) => v && ({
                        components: { title: v.title, icon: v.titleIcon }
                    })
                }
            },
            image: {
                css: 'card-image',
                templates: {
                    content: {
                    // image
                    }
                }
            },
            content: {
                css: 'card-content'
            },
            footer: {
                css: 'card-footer',
                defaultItem: {
                    css: 'card-footer-item'
                }
            }
        },
        // bindings: {
        //     model: (v: any) => ({components: v})
        // }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        css: props.css,
        components: {
            image: !!props.image && {
                components: {
                    content: props.image
                }
            },
            header: props.header,
            content: !!props.content && {
                components: {
                    content: props.content
                }
            }
        },
        // defaults: {
        //     model: () => observable({
        //         title: '',
        //         titleIcon: false
        //     })
        // }
        // scope: {
        //     model: () => observable(props)
        // }
        // scope: {
        //     model: () => observable(props),
        // }
    });
};
